module.exports = __webpack_public_path__ + "static/img/3.f120a57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/3.png
// module id = k/tb
// module chunks = 0